function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { MarketplaceHttpClient } from './marketplace-http-client';
class ServerMethodHttpClient extends MarketplaceHttpClient {
    constructor(...args){
        super(...args), _define_property(this, "invokeServerMethod", (appId, name, payload)=>{
            return this.post(`/apps/${appId}/server-actions/${name}/run`, payload);
        });
    }
}
export const ServerMethodApi = new ServerMethodHttpClient();
